import { api, TmrBaseResource, responseErrorCheck, ResourcePage, ItemIdentifier } from 'stylewhere/api'

export class ItemIdentifiers extends TmrBaseResource {
  static endpoint = `/api/v1/itemIdentifiers`

  static async search<T = ItemIdentifier>(searchParams = {}): Promise<ResourcePage<T>> {
    return api.get<ResourcePage<T>>(`${this.endpoint}`, searchParams).then(responseErrorCheck)
  }
}
